module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('scroll', {
    class: {
      'to-bottom-btn': _vm.toBottomBtn
    },
    on: {
      "refresh": _vm.refresh
    }
  }, [_c('div', [_c('section', [_c('div', {
    staticClass: "text-center row thick bg-gray"
  }, [_c('span', {
    staticClass: "f-minor"
  }, [_vm._v("订单状态：")]), _vm._v(" "), (
    _vm.regDetail.regStatus === 4 &&
    (_vm.regDetail.orderStatus === 1 || _vm.regDetail.orderStatus === 2)
  ) ? _c('span', {
    staticClass: "f-strong"
  }, [_vm._v("已预约")]) : (_vm.regDetail.regStatus === 5) ? _c('span', {
    staticClass: "f-strong"
  }, [_vm._v("已取消")]) : (_vm.regDetail.orderStatus === 3) ? _c('span', {
    staticClass: "f-strong"
  }, [_vm._v("已支付")]) : (_vm.regDetail.orderStatus === 4) ? _c('span', {
    staticClass: "f-strong"
  }, [_vm._v("已支付")]) : (_vm.regDetail.orderStatus === 5) ? _c('span', {
    staticClass: "f-strong"
  }, [_vm._v("已退号")]) : _vm._e()]), _vm._v(" "), _c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("医院")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.regDetail.hospitalName))])]), _vm._v(" "), _c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("院区科室")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.regDetail.areaName) + "/" + _vm._s(_vm.regDetail.deptName))])]), _vm._v(" "), _c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("科室地址")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.regDetail.deptAddress))])]), _vm._v(" "), _c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("医生")]), _vm._v(" "), _c('dd', [_c('span', {
    staticClass: "mydoctor"
  }, [_vm._v(_vm._s(_vm.regDetail.doctName))])])]), _vm._v(" "), _c('dl', {
    staticClass: "field last"
  }, [_c('dt', [_vm._v("门诊类型")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.regDetail.typeName) + "门诊")])])]), _vm._v(" "), _c('section', [_c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("就诊人")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.regDetail.holderName) + "/" + _vm._s(_vm.mobileNo))])]), _vm._v(" "), _c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("就诊时间")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm._f("formatDate")(_vm.regDetail.visitTime)))])]), _vm._v(" "), _c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("就诊序号")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.regDetail.visitNo))])]), _vm._v(" "), _c('dl', {
    staticClass: "field last"
  }, [_c('dt', [_vm._v("挂号时间")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm._f("formatDate")(_vm.regDetail.orderTime)))])])]), _vm._v(" "), _c('section', [_c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("订单号")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.regDetail.orderId))])]), _vm._v(" "), _c('dl', {
    staticClass: "field last"
  }, [_c('dt', [_vm._v("挂号金额")]), _vm._v(" "), _c('dd', {
    staticClass: "f-strongest"
  }, [_vm._v(_vm._s(_vm._f("formatFee")(_vm.regDetail.fee)))])])])]), _vm._v(" "), (_vm.regDetail.areaType === '1') ? _c('section', {
    staticClass: "tips mytips"
  }, [_c('span', {
    staticClass: "f-strong"
  }, [_vm._v("提示信息：")]), _vm._v(" "), _c('br'), _vm._v("\n      1、请您在预约时间前30分钟到达医院对应科室候诊。 "), _c('br'), _vm._v("\n      2、如您不能按时就诊，请提前一天（晚上凌晨以前）取消预约，系统会自动退还预约费用。\n      "), _c('br'), _vm._v("\n      3、如果当天需要取消预约，请在门诊收费窗口办理。\n    ")]) : _vm._e(), _vm._v(" "), (_vm.regDetail.areaType === '2') ? _c('section', {
    staticClass: "tips mytips"
  }, [_c('span', {
    staticClass: "f-strong"
  }, [_vm._v("提示信息：")]), _vm._v(" "), _c('br'), _vm._v("请您携带居民健康卡在预约时间前30分钟到达医院支付挂号费取号。\n    ")]) : _vm._e()]), _vm._v(" "), _c('footer', [(_vm.regDetail.orderStatus === 2 && _vm.regDetail.regStatus === 4) ? _c('div', {
    staticClass: "flex-row flex-align-center"
  }, [_c('div', {
    staticClass: "flex-1 flex-width",
    staticStyle: {
      "padding": "0 0.5rem"
    }
  }, [_c('span', {
    staticClass: "myfee"
  }, [_vm._v("总金额")]), _vm._v(" "), _c('span', {
    staticClass: "f-strongest"
  }, [_vm._v(_vm._s(_vm._f("formatFee")(_vm.regDetail.fee)))])]), _vm._v(" "), _c('button', {
    staticClass: "btn-bottom-right",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goPay()
      }
    }
  }, [_vm._v("立即缴费")])]) : _vm._e(), _vm._v(" "), (_vm.isPaySuccess) ? _c('button', {
    staticClass: "btn-complete",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.finished()
      }
    }
  }, [_vm._v("\n      完成\n    ")]) : _vm._e()]), _vm._v(" "), _c('payConfirm', {
    model: {
      value: (_vm.showPayConfirm),
      callback: function($$v) {
        _vm.showPayConfirm = $$v
      },
      expression: "showPayConfirm"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76a283bb","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/myregister/RegDetail.vue
// module id = 857
// module chunks = 0